define('viewModels/widgets/ListPicker',[
    'viewModels/ViewModel',
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'services/loggingService',
    'util/errorCallbackFactory',
    'viewModels/widgets/SortablePanels'
], function (ViewModel, ko, _, Promise, LOG, errorCallbackFactory, SortablePanels) {
    'use strict';

    var ListPicker = ViewModel.extend(function (searchFunction, displayProperty) {
        var self = this;

        // The item currently selected in the combobox
        self.selectedItem = ko.observable(null);
        // Whether to show the spinner or not
        self.loadingList = ko.observable(false);

        // Placeholder for the combobox
        self.comboboxPlaceholder = '';

        self.sortablePanels = self.subView(SortablePanels);
        // Placeholder for when there are no items in the list
        self.sortablePanels.placeholderText = '';

        self.listItems =  ko.observableArray();

        self.isSelectionBoxDisabled = ko.observable(false);

        self.displayProperty = displayProperty;

        self.searchFunction = searchFunction;

        //Filters out results in combobox if their already in the list
        self.filteredSearch = function(queryTerm) {
            return searchFunction(queryTerm).then(function(items){
                    return _.filter(items, function(item){
                        return _.find(self.listItems(), { 'id': item.id }) === undefined;
                    });
                });
        };

        /**
         * Controls whether the placeholder text is shown
         */
        self.hasItems = self.computed(function () {
            return self.sortablePanels.panels().length > 0;
        });
        var addPanel = function (item) {
            return self.sortablePanels.createPanel(
                item[displayProperty],
                item,
                self.template,
                self.sortablePanels.panels().length
            );
        };
        self.removeAllPanels = function() {
            self.sortablePanels.panels.removeAll();
        };
        /**
         * Starts property subscriptions
         */
        self.startWatching = function(){
            /**
             * Adds the endpoint selected in the combobox to the end of the list
             */
            self.subscribe(self.selectedItem, function(selectedValue) {
                if(_.hasValue(selectedValue)) {
                    addPanel(selectedValue);
                    self.selectedItem(undefined);
                }
            });

            /**
             * Updates list based on panel changes
             */
            self.subscribe(self.sortablePanels.panels, function(panels){
                self.listItems(_.map(panels, 'viewModel'));
            });
        };

        /**
         * The configure function for this widget.
         *  options:
         *      autoSort: Whether to auto sort the list. This will disable user ordering if true.
         *      enableOrdering: Whether to allows users ordering in the list portion of the control.
         *      list: Observable array that contains the items in the list. This array will be updated as the list is updated.
         *      template: Template used for a row within the List
         *      comboboxPlaceholder: Placeholder text to use for the combobox
         *      emptyPlaceHolder: Placeholder text to use when the list is empty
         */
        self.configure = function (options) {
            var opts = _.assign({
                autoSort: false,
                enableOrdering: false,
                list: ko.observableArray([]),
                template: undefined,
                comboboxPlaceholder: '',
                emptyPlaceholder: ''
            }, options);

            self.sortablePanels.autoSort(opts.autoSort);
            self.sortablePanels.panels([]);
            self.sortablePanels.orderable(opts.enableOrdering);
            self.listItems = opts.list;
            self.template = opts.template;
            self.comboboxPlaceholder = opts.comboboxPlaceholder;
            self.sortablePanels.placeholderText = opts.emptyPlaceholder;
            self.sortablePanels.enableOrdering = opts.enableOrdering;

            self.renderPanels = function() {
                var items = self.listItems();
                self.sortablePanels.panels.removeAll();
                _.each(items, function(item){
                    addPanel(item);
                });
            };

            self.renderPanels();
            self.startWatching();
        };
    });

    return ListPicker;
});

